module.exports = __webpack_public_path__ + "static/media/p5_9.196c5a97.jpeg";